import {$, $$, createElement, createIcon, getParentElementByTagName, html_chargement_en_cours} from "../../core/js/Dom.ts";
import {initNotes, initNotesForm} from "../../core/js/Notes.ts";
import {createModale, hideModal, showModal} from "../../core/js/Modal.ts";
import {SelecteurDeServices} from "../../core/js/SelecteurDeServices.ts";
import type {OptionOptional} from "slim-select/dist/store";
import {$get, $post} from "../../core/js/Ajax.ts";

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.url?.startsWith("prescription")) {
        if ($('#prescription_service_concerne_tableau')) {
            addCategorieServiceConcerne()
        }
        updateTableau()
        initPrescriptionUpdateEvenementPrecedent()

        $('#prescription-ajout-service')?.addEventListener('click', () => {
            initSelecteurDeService()
        })
        const notesContaier = $('#container-note-prescription')
        if (notesContaier) {
            initNotesForm(notesContaier)
            initNotes(notesContaier)
        }
        selectionnerCheckboxesServiceAInformer()
        initNotifierLesServices()
    }
})

export function addCategorieServiceConcerne() {
    const tr_service_concerne = $$('.tr_service_concerne');
    if (tr_service_concerne.length > 0) {
        let categorie = tr_service_concerne[0].dataset.categorie;
        tr_service_concerne[0].insertAdjacentHTML('beforebegin',
            createCategoryRow(categorie)
        );
        tr_service_concerne.forEach((row) => {
            if (row.dataset.categorie !== categorie) {
                categorie = row.dataset.categorie
                row.insertAdjacentHTML('beforebegin',
                    createCategoryRow(categorie)
                );
            }
        });
    }
}

function createCategoryRow(categorie: string | undefined) {
    return `<tr class="bg-secondary text-white"><th scope="row" colspan="4">${categorie}</th></tr>`;
}

function initTableauListeners() {
    $$(".select_checkbox_service").forEach(element => element.addEventListener('click', handleServiceClick))
}

function remplirTableauBySelectedInput(id: string, colone: string) {
    const selectElement = $<HTMLSelectElement>(`#${id}`);
    if (selectElement) {
        const selectedOptions = Array.from(selectElement.selectedOptions);
        selectedOptions.forEach(option => {
            let string_input = `checkbox_${colone}_${option.value}`
            let input = $<HTMLInputElement>(`#${string_input}`)
            if (input && !input.checked) {
                let cellule_input = $('[data-input="' + string_input + '"]');
                cellule_input?.click()
            }
        });
    }
}

export function initPrescriptionUpdateEvenementPrecedent() {
    const select = $<HTMLSelectElement>('#id_reference_evenement_precedent_m2m')
    if (select) {
        // Ajoute les dossiers au champ reference lorsqu'ils sont sélectionnés
        $$(".select-reference-manif").forEach(input => {
            input.addEventListener('change', (event: DOMEvent<HTMLInputElement>) => {
                const element = event.target
                if (element.checked) {
                    // si selection, on sélectionne toutes les checkboxes qui ont la même valeur
                    $$<HTMLInputElement>(`.id_reference_evenement_precedent_m2m_${element.value}`).forEach(input => {
                        input.checked = true
                    })
                    addSelectSelectedOption(select, element.value, element.dataset.name)
                } else {
                    const option = $<HTMLOptionElement>(`option[value='${element.value}']`, select)
                    if (option) {
                        option.selected = false
                        option.removeAttribute('selected')
                        select.slim?.setSelected(select.slim?.getSelected().filter(val => val !== element.value))
                    }
                }
            })
        })

        // Ajoute un checked aux évènements initialement sélectionnés
        requestAnimationFrame(() => {
            const elements = select.slim?.getSelected()
            elements?.forEach(element => {
                $$<HTMLInputElement>(`.id_reference_evenement_precedent_m2m_${element}`).forEach(input => {
                    input.checked = true
                })
            })
        })

        // deselecte les elements qui ne sont plus dans le select
        select.addEventListener('change', () => {
            const selected = select.slim?.getSelected()
            const inputChecked = [...$$<HTMLInputElement>('.select-reference-manif:checked')].map((input) => input.value) as string[]
            if (selected && inputChecked) {
                let difference = inputChecked.filter(x => !selected.includes(x));
                difference.forEach(element => {
                    const inputs = $$<HTMLInputElement>(`.select-reference-manif[value='${element}']`)
                    inputs.forEach(input => input.checked = false)
                })
            }
        })
    }
}

function initSelecteurDeService() {
    const modale = createModale('multi_select', {
        title: window.Openscop.selecteur.prescription.modal_title,
    })
    if (modale) {
        showModal('multi_select', {
            disableScroll: true,
        })
        const selecteur = new SelecteurDeServices(window.Openscop.selecteur.prescription)

        selecteur.addEventListener('selecteur:multiple', (event) => {
            const data: OptionOptional[] = (event as CustomEvent).detail
            const select = $<HTMLSelectElement>('#id_liste_des_services_concerne')
            if (select && data) {
                data.forEach((newData: OptionOptional) => {
                    if (newData.value) addSelectSelectedOption(select, newData.value.split('_')[0], newData.text)
                    hideModal('multi_select')
                })
                requestAnimationFrame(() => {
                    updateTableau()
                })
            }
        })
    }
}


function addSelectSelectedOption(select: HTMLSelectElement, value: string, text: string) {
    const optionExist = $<HTMLOptionElement>(`option[value='${value}']`, select)
    if (optionExist) {
        optionExist.selected = true
        optionExist.setAttribute('selected', 'true')
    } else {
        const option = createElement('option')
        option.value = value
        option.textContent = text
        select.add(option)
        option.selected = true
        option.setAttribute('selected', 'true')
    }
}

export function updateTableau() {
    const form = $<HTMLFormElement>('#form-prescription')
    const container = $('#tableau-services')
    if (form && container) {
        container.innerHTML = ""
        container.appendChild(html_chargement_en_cours())

        const data = new FormData(form)
        const services = data.getAll('liste_des_services_concerne')
        const saisir = data.getAll('liste_des_services_a_saisir_m2m')
        const informer = data.getAll('liste_des_services_a_informer_m2m')
        const attribuer = data.getAll('liste_des_services_a_attribuer_m2m')

        const headers = new Headers()
        headers.append('Content-Type', 'application/json')
        $post(container.dataset.url!, {
            services,
            saisir,
            informer,
            attribuer,
        }, headers).then(response => {
            container.innerHTML = response.body
            initTableauListeners()
            addCategorieServiceConcerne()
            remplirTableauBySelectedInput('id_liste_des_services_a_saisir_m2m', 'saisir')
            remplirTableauBySelectedInput('id_liste_des_services_a_informer_m2m', 'info')
            remplirTableauBySelectedInput('id_liste_des_services_a_attribuer_m2m', 'attribuer')
        })
    }
}

function handleServiceClick(event: DOMEvent<HTMLInputElement>) {
    const td = getParentElementByTagName(event.target, 'td')
    const service_pk = td?.getAttribute('data-service-pk')
    const input = $<HTMLInputElement>(`#${td?.getAttribute('data-input')}`)
    const select = $<HTMLSelectElement>(`#${td?.getAttribute('data-field')}`)
    if (td && input && service_pk && select) {
        if (input.checked) {
            input.checked = false
            const option = $<HTMLOptionElement>(`option[value='${service_pk}']`, select)
            if (option && option.selected) {
                option.selected = false
                option.setAttribute('selected', 'false')
            }
            $('i', td)?.remove()
        } else {
            input.checked = true
            addSelectSelectedOption(select, `${service_pk}`, `${service_pk}`)
            const icon = createIcon(td.getAttribute('data-icone-class')!)
            td.appendChild(icon)
        }
    }
}

function selectionnerCheckboxesServiceAInformer() {
    const selectAllCheckboxes = $$<HTMLInputElement>('.select_all');
    selectAllCheckboxes.forEach((selectAllCheckbox) => {
        selectAllCheckbox.addEventListener('change', (event: DOMEvent<HTMLElement>) => {
            const target = event.target
            const checkboxes = $$<HTMLInputElement>(".checkbox_service", target.closest('table'));
            checkboxes.forEach((checkbox) => {
                checkbox.checked = selectAllCheckbox.checked;
            });
        });
    });

    const individualCheckboxes = $$('.checkbox_service');
    individualCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', (event: DOMEvent<HTMLInputElement>) => {
            const target = event.target
            let allChecked = true;
            const checkboxes = $$<HTMLInputElement>(".checkbox_service", target.closest('table'))
            checkboxes.forEach((checkbox) => {
                if (!checkbox.checked) {
                    allChecked = false;
                }
            });
            const selectAll = $<HTMLInputElement>(".select_all", target.closest('table'))
            if (selectAll) selectAll.checked = allChecked;
        });
    });
}

export function addListenerBtnReponseDemandeValidation() {
    let buttons = $$(".btn_reponse_demande_validation");
    buttons.forEach(function (button) {
        button.addEventListener('click', function (event: DOMEvent<HTMLElement>) {
            const target = event.target
            let id = target.getAttribute('data-pk');
            let url = target.getAttribute('data-url');
            $get(url).then((response) => {
                const container = $(`#formulaire_reponse_demande_validation_container_${id}`);
                if (container) {
                    container.innerHTML = response.body;
                }
            })
        })
    })
}

export function initNotifierLesServices() {
    $$<HTMLSelectElement>(".select_model_message").forEach((element) => {
        if (element.value) {
            get_model_message_form(element.value, element.getAttribute('data-control'))
        }
    })

    $$<HTMLSelectElement>(".select_model_message").forEach(element => element.addEventListener('change', () => {
        if (element.value) {
            get_model_message_form(element.value, element.getAttribute('data-control'))
        }
    }))

    function get_model_message_form(url: string | undefined, container_selector: string | undefined | null) {
        if (url && container_selector) {
            $get(`${url}?id=${container_selector}`).then((reponse) => {
                const container = $(`#${container_selector}`)
                if (container) {
                    container.innerHTML = reponse.body
                    let corps_name = container_selector.split('_').pop();
                    $('textarea', container)?.setAttribute('name', `corps_${corps_name}`)
                    $('.textinput', container)?.setAttribute('name', `objet_${corps_name}`)
                    $('input[name=type]', container)?.setAttribute('name', `type_${corps_name}`)

                }
            })
        }
    }
}